
import { defineComponent } from 'vue'
import IconX from '@/components/IconX.vue'

export default defineComponent({
  components: {
    IconX
  },

  props: {
    isOpen: {
      default: false,
      type: Boolean
    }
  },

  emits: ['close']
})
